import React, { useState, useEffect } from "react";
import * as S from "../css/AddBarcode.styles";
import MenuComponent from "../component/MenuComponent";
import { loginState } from "../stores/loginState";
import { useRecoilState, useRecoilValue } from "recoil";
import { useGetStatus } from "../api/addbarcode/useGetStatus";
import dayjs from "dayjs";
import { barcodeAddState } from "../stores/addbarcode/barcodeAddState";
import { useAddBarcode } from "../api/addbarcode/useAddBarcode";
import Loading from "../component/Loading";
import { formatNumberCommas } from "../utils/formatNumberCommas";
import { selectBarcodeState } from "../stores/addbarcode/selectBarcodeState";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { addBarcodeResultState } from "../stores/addbarcode/addBarcodeResultState";

function AddBarcode(props) {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const [selectedData, setSelectedData] = useRecoilState(selectBarcodeState); // 운송장 등록정보
  const [isLoading, setIsLoading] = useState(false); // 로딩 여부
  const [lineCount, setLineCount] = useState(0); // 누락운송장 등록 건수 체크
  const addData = useRecoilValue(barcodeAddState); // 운송장 추가등록 점소 정보 데이터
  const resultData = useRecoilValue(addBarcodeResultState); // 등록 결과 데이터
  const [warningMessage, setWarningMessage] = useState(""); // 경고 메시지 상태
  
  // TODO 해당 날짜의 운송장 추가등록에 필요한 점소 정보 호출 API
  const { mutate: getStatus } = useGetStatus(
    selectedData.date
  );

  // TODO 운송장 등록 API
  const { mutate: addBarcode } = useAddBarcode(setIsLoading);

  // NOTE 등록 버튼 클릭 시
  const handleRegister = () => {
    setIsLoading(true);
    const barcodeList = selectedData.barcode
    .split('\n')
    .map(barcode => barcode.trim())
    .filter(barcode => barcode !== '' && barcode.length >= 9 && barcode.length <= 16); // 9자 이상, 16자 이하만 필터링
  
    // 현재 시간부터 시작하여 1초씩 증가하는 형식으로 scan_total_time과 scantime을 생성
    const startTime = dayjs().format("YYYY-MM-DD 06:00:00");

    const dataList = barcodeList.map((barcode, index) => {

    // 인덱스에 따라 scan_total_time과 scantime을 1초씩 증가
    const currentTime = dayjs(startTime).add(index, 'second').format("YYYY-MM-DD HH:mm:ss");
    const currentScantime = dayjs(startTime).add(index, 'second').format("HH:mm:ss");
  
      return {
        emp_cd: selectedData.empcd,
        tg_bran_cd: selectedData.tgbran,
        pob: selectedData.pob,
        car_num: selectedData.car,
        scandate: selectedData.date,
        tm_dv: selectedData.tmdv,

        bran_cd: login.branchCode,
        dev_serial: "watcher",
        dev_ver: "",

        barcode: barcode,
        scan_total_time: currentTime,
        scantime: currentScantime,
      };
    });
  
    // 모든 데이터 객체를 배열로 묶어서 한번에 서버에 전송
    addBarcode(dataList);
  }; 

  // NOTE 페이지 로딩 시, 날짜 변경 감지 시
  useEffect(() => {
    getStatus();
  }, [selectedData.date, getStatus]);  

  // NOTE 누락운송장번호 등록에 값 입력 시
  const handleTextareaChange = (e) => {
    const value = e.target.value;
    setSelectedData((prevState) => ({
      ...prevState,
      barcode: value,
    }));
  
    const barcodeList = value.split('\n');
    setLineCount(barcodeList.length);
  
    // 8자 이하 또는 17자 이상의 운송장이 있는지 검사
    const hasInvalidBarcode = barcodeList.some(
      (barcode) => barcode.length < 9 || barcode.length > 16
    );
    
    // 경고 메시지 설정
    setWarningMessage(hasInvalidBarcode ? "일부 올바른 형식이 아닌 운송장은 누락될 수 있습니다.\n9자 이상, 16자 이하의 운송장 정보를 입력해주세요." : "");
  };
  

  // NOTE 페이지 로딩 시 기본 날짜, 업무구분 설정
  useEffect(() => {
    // 처음 페이지 로딩 시 업무일자 오늘, 업무구분은 배송입고로 설정
    if (selectedData.date === "") setSelectedData(prev => ({ ...prev, date:dayjs().format("YYYY-MM-DD")}));
    if (selectedData.tmdv === "") setSelectedData(prev => ({ ...prev, tmdv:login.company === "LOGEN" ? "60" : "21"}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
      {isLoading && <Loading />}
        <h4>운송장 추가등록</h4>
        <S.FlexContainer>
          <S.EditContainer>
            <S.EditSpan>
              <h5>업무일자</h5>
              <S.Input type="date" value={selectedData.date} onChange={(e) =>
                  setSelectedData((prevState) => ({
                    ...prevState,
                    date: e.target.value,
                  }))} />
            </S.EditSpan>
            <S.EditSpan>
              <h5>업무구분</h5>
              <S.SelectContainer value={selectedData.tmdv} onChange={(e) =>
                  setSelectedData((prevState) => ({
                    ...prevState,
                    tmdv: e.target.value,
                  }))}>
              <option disabled>선택해주세요.</option>
                <option value={login.company === "LOGEN" ? "60" : "21"}>
                  {login.company === "LOGEN" ? "배송입고 (60)" : "도착 (21)"}
                </option>
                <option value={login.company === "LOGEN" ? "30" : "20"}>
                  {login.company === "LOGEN" ? "집하출고 (30)" : "발송 (20)"}
                </option>
              </S.SelectContainer>
            </S.EditSpan>
            <S.EditSpan>
              <h5>작업영업소</h5>
              <S.Input value={login.branchCode} readOnly style={{ background: props.theme.white2 }} />
            </S.EditSpan>
            <S.EditSpan>
              <h5>작업영업소사원</h5>
              <Autocomplete
                value={selectedData.empcd}
                disablePortal
                id="combo-box-demo"
                options={addData.emp_cd || []}
                filterOptions={(options) => options} // 모든 옵션을 그대로 반환하여 필터링을 비활성화
                sx={{ width: 150, height: 28 }}
                renderInput={(params) => (
                  <TextField {...params} label="입력하거나 선택해주세요." variant="outlined" />
                )}
                onChange={(event, newValue) => {
                  setSelectedData((prevState) => ({
                    ...prevState,
                    empcd: newValue || '', // newValue는 선택된 값, 없으면 빈 문자열
                  }));
                }}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue !== selectedData.empcd) { // 무한 루프 방지
                    setSelectedData((prevState) => ({
                      ...prevState,
                      empcd: newInputValue || '', // 직접 입력한 값도 상태에 반영
                    }));
                  }
                }}
              />
            </S.EditSpan>
            <S.EditSpan>
              <h5>상대영업소</h5>
              <Autocomplete
                value={selectedData.tgbran}
                disablePortal
                id="combo-box-demo"
                options={addData.tg_bran_cd || []}
                filterOptions={(options) => options} // 모든 옵션을 그대로 반환하여 필터링을 비활성화
                sx={{ width: 150, height: 28 }}
                renderInput={(params) => (
                  <TextField {...params} label="입력하거나 선택해주세요." variant="outlined" />
                )}
                onChange={(event, newValue) => {
                  setSelectedData((prevState) => ({
                    ...prevState,
                    tgbran: newValue || '', // newValue는 선택된 값, 없으면 빈 문자열
                  }));
                }}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue !== selectedData.tgbran) { // 무한 루프 방지
                    setSelectedData((prevState) => ({
                      ...prevState,
                      tgbran: newInputValue || '', // 직접 입력한 값도 상태에 반영
                    }));
                  }
                }}
              />
            </S.EditSpan>
            <S.EditSpan>
              <h5>상대영업소사원</h5>
              <Autocomplete
                value={selectedData.pob}
                disablePortal
                id="combo-box-demo"
                options={addData.pob || []}
                filterOptions={(options) => options} // 모든 옵션을 그대로 반환하여 필터링을 비활성화
                sx={{ width: 150, height: 28 }}
                renderInput={(params) => (
                  <TextField {...params} label="입력하거나 선택해주세요." variant="outlined" />
                )}
                onChange={(event, newValue) => {
                  setSelectedData((prevState) => ({
                    ...prevState,
                    pob: newValue || '', // newValue는 선택된 값, 없으면 빈 문자열
                  }));
                }}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue !== selectedData.pob) { // 무한 루프 방지
                    setSelectedData((prevState) => ({
                      ...prevState,
                      pob: newInputValue || '', // 직접 입력한 값도 상태에 반영
                    }));
                  }
                }}
              />
            </S.EditSpan>
            <S.EditSpan>
              <h5>차량번호</h5>
              <Autocomplete
                value={selectedData.car}
                disablePortal
                id="combo-box-demo"
                options={addData.car_num || []}
                filterOptions={(options) => options} // 모든 옵션을 그대로 반환하여 필터링을 비활성화
                sx={{ width: 150, height: 28 }}
                renderInput={(params) => (
                  <TextField {...params} label="입력하거나 선택해주세요." variant="outlined" />
                )}
                onChange={(event, newValue) => {
                  setSelectedData((prevState) => ({
                    ...prevState,
                    car: newValue || '', // newValue는 선택된 값, 없으면 빈 문자열
                  }));
                }}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue !== selectedData.car) { // 무한 루프 방지
                    setSelectedData((prevState) => ({
                      ...prevState,
                      car: newInputValue || '', // 직접 입력한 값도 상태에 반영
                    }));
                  }
                }}
              />
            </S.EditSpan>
            <hr />
            <h6>
              업무일자를 변경할 시 점소 정보들이 해당 일자에 맞게 업데이트됩니다.<br/>
              모든 점소 정보를 설정하셔야 송장등록이 가능합니다.<br/>
              모든 점소 정보를 입력하지 않을 시 등록 처리가 되지 않습니다.<br/>
              차량번호는 선택기능과, 직접입력 기능이 있습니다.<br/>
              유사시 차량번호를 직접 입력하실 수 있으며,<br/>
              운송장 등록 시 저장되는 차량번호의 기준은 직접입력 칸 기준입니다.
            </h6>
            <hr />
            <h6>
              누락운송장번호는 여러 줄을 입력하실 수 있습니다.<br />
              운송장 번호를 하나만 입력 할 시 기본 06시 정각이며,<br />
              여러 운송장을 입력할 시 06시 정각부터 시작하여<br />
              1초씩 경과하는 형식으로 추가됩니다.
            </h6>
          </S.EditContainer>
          <S.Line />
          <S.EditContainer>
            <h5>누락운송장번호 등록</h5>
            <S.TextArea
              defaultValue={selectedData.barcode}
              onInput={(e) => e.target.value = e.target.value.replace(/[^\d\n]/g, '')} // 숫자와 줄바꿈만 사용할 수 있음
              placeholder="운송장번호를 입력해주세요."
              onChange={handleTextareaChange}/>
            {warningMessage && <p style={{ color: "red" }}>
              {warningMessage.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}</p>}
            <p>검색된 운송장 : {formatNumberCommas(lineCount)} 건</p>
          </S.EditContainer>
        </S.FlexContainer>
        <S.ButtonSpan>
        <S.Button onClick={handleRegister} style={{ position: "absolute"}}>등록</S.Button>
        </S.ButtonSpan>
      </S.ContentContainer>
      <S.ContentContainer>
        <h4>운송장 등록결과</h4>
        <S.FlexContainer>
          <S.EditContainer>
            <h5>등록 성공</h5>
            <S.ResultContainer>
              {resultData.success_list && resultData.success_list.length > 0 ? (
                resultData.success_list.map((item, index) => {
                  const [code, number] = item.split('-'); // '-'를 기준으로 문자열 분리
                  let status;
                  switch (code) {
                    case '60':
                      status = '배송입고(60)';
                      break;
                    case '30':
                      status = '집하출고(30)';
                      break;
                    case '21':
                      status = '도착(21)';
                      break;
                    case '20':
                      status = '발송(20)';
                      break;
                    default:
                      status = '알 수 없는 코드';
                  }
                  return (
                    <div key={index}>
                      {status} - {number}
                    </div>
                  );
                })
              ) : (
                <div>데이터가 존재하지 않습니다.</div> // 성공 목록이 비어있을 경우 표시될 기본 텍스트
              )}
            </S.ResultContainer>
            <p>등록된 운송장 : {formatNumberCommas(resultData.count || 0)} 건</p>
          </S.EditContainer>
          <S.Line />
          <S.EditContainer>
            <h5>등록 실패</h5>
            <S.ResultContainer>
              {resultData.fail_list && resultData.fail_list.length > 0 ? (
                resultData.fail_list.map((item, index) => {
                  // item을 공백 기준으로 분리
                  const barcode = item.split("barcode : ")[1].split(" message : ")[0];
                  const message = item.split("message : ")[1];

                  return (
                    <div key={index}>
                      {message} - {barcode}
                    </div>
                  );
                })
              ) : (
                <div>데이터가 존재하지 않습니다.</div>
              )}
            </S.ResultContainer>
            <p>등록 실패 운송장 : {formatNumberCommas(resultData.fail || 0)} 건</p>
          </S.EditContainer>
        </S.FlexContainer>
      </S.ContentContainer>
    </S.DashboardContainer>
  );
}

export default AddBarcode;
